// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Feed from './pages/Feed';
import Add from './pages/Add';
import Games from './pages/Games';
import Search from './pages/Search';
import Cores from './pages/Cores';
import Core from './pages/Core';
import Game from './pages/Game';
import Ad from './components/Ad';
import Batch from './pages/Batch';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Feed />} />
          <Route path="/ad" element={<Ad />} />
          <Route path="/adicionar" element={<Add />} />
          <Route path="/lote" element={<Batch />} />
          <Route path="/jogos" element={<Games />} />
          <Route path="/pesquisar" element={<Search />} />
          <Route path="/cores" element={<Cores />} />
          <Route path="/:core" element={<Core />} />
          <Route path="/:core/:slug" element={<Game />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;